export default __webpack_public_path__ + "static/media/img_company_header29.deff20dd.png";